import { createMuiTheme, Theme as MuiTheme, ThemeOptions } from '@material-ui/core/styles';
import 'fontsource-roboto';

// import AVENIRNEXTLTPRO from '../fonts/AVENIRNEXTLTPRO-REGULAR_0.ttf';

// TODO: Extend the theme for common components using module augmentation:
// https://material-ui.com/customization/palette/
// https://material-ui.com/guides/typescript/#customization-of-theme
export interface Theme extends MuiTheme {
  menu: {
    width: number,
    widthCollapsed: number,
    background: string,
    color: string,
  }
  extraColors: {
    positiveAmount: string,
    negativeAmount: string,
    warning: string
  }
}

const themeOptions: ThemeOptions = {
  palette: {
    primary: {
      light: "#5299e8",
      main: "#00609c",
      dark: "#1b599e",
      contrastText: "#fff"
    },
    secondary: {
      light: "#f7be00",
      main: "#00adbb",
      dark: "#ab003c"
    },
    text: {
      primary: 'rgba(0,0,0,0.70)',
      secondary: 'rgba(0,0,0,0.54)',
      disabled: 'rgba(0,0,0,0.38)',
      hint: 'rgba(0,0,0,0.38)',
    },
    error: {
      light: '#e57373',
      main: '#e13023',
      dark: '#d32f2f',
    },
    warning: {
      light: '#ffb74d',
      main: '#ff9800',
      dark: '#f57c00',
    },
    success: {
      light: "#81c784",
      main: "#4caf50",
      dark: "#388e3c"
    }
  },

  typography: {
    fontFamily: "Roboto"
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '.menuPaper': {  boxSizing: 'content-box' },
      }
    }
  }
};

const baseTheme = createMuiTheme(themeOptions);

const mainTheme: Theme = {
  ...baseTheme,
  menu: {
    width: 225,
    widthCollapsed: baseTheme.spacing(7.15),
    background: '#fff',
    color: 'black', 
  },
  extraColors: {
    positiveAmount: '#A3D977',
    negativeAmount: '#E81922',
    warning: '#F19837'
  }
}

const theme = {
  ...mainTheme,
}

export default theme;
